// Voorstellen beslissen in Opschonen (planner). Goedkeuren zet de datum in Planner en geeft een wijziging terug die
// Ongedaan maken kan terugdraaien; heropenen zet het voorstel daarna weer open.
import { call } from "./api";
import type { OpsResult } from "./types";

export interface ApproveResult extends OpsResult {
  proposalId: number;
}

export interface DecideResult {
  ok: boolean;
  proposalId: number;
}

export const proposalApi = {
  approve: (id: number) => call<ApproveResult>("POST", `/api/proposals/${id}/approve`, {}),
  reject: (id: number) => call<DecideResult>("POST", `/api/proposals/${id}/reject`, {}),
  reopen: (id: number) => call<DecideResult>("POST", `/api/proposals/${id}/reopen`, {}),
};
